"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalWindow = void 0;
const local_storage_1 = require("../../../../utils/local-storage");
const button_1 = require("../../../../view-components/buttons/button");
const setfunc_1 = require("../../header/setfunc");
class ModalWindow {
    constructor(id) {
        this.modalText = {
            title: 'logout process',
            username: (0, local_storage_1.getLogin)().name
        };
        this.modal = document.createElement('div');
        this.modal.id = id;
    }
    render() {
        this.modal.innerText = `You really want logout, ${this.modalText.username}?`;
        const butContainer = document.createElement('div');
        butContainer.classList.add('modal-but-container');
        const yesLogout = button_1.ButtonEl.render('logout', 'Yes');
        const noLogout = button_1.ButtonEl.render('no-logout', 'No');
        yesLogout.addEventListener('click', setfunc_1.logoutFunc);
        noLogout.addEventListener('click', setfunc_1.PopupLogout);
        butContainer.append(yesLogout);
        butContainer.append(noLogout);
        this.modal.append(butContainer);
        return this.modal;
    }
}
exports.ModalWindow = ModalWindow;
